import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<h2>Allocate</h2><table class=\"table table-hover\"><thead><th>Date</th><th>Address</th><th>Ref</th><th>Item</th><th>Client</th><th>PI</th><th>Preffered PI</th><th>QC Continuity</th><th>Assign</th></thead><tbody><tr><td>test</td><td>test</td><td>test</td><td>test</td><td>test</td><td>test</td><td>test</td><td>test</td><td><input type=\"checkbox\"></td></tr></tbody></table>", 2)
const _hoisted_3 = [
  _hoisted_1
]

import { computed, inject, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Auth from "@aws-amplify/auth";
import { useStore } from 'vuex';
import moment from "moment-timezone";
import { useToast } from "vue-toastification";
import Ably from "ably";


export default /*#__PURE__*/_defineComponent({
  __name: 'Allocate',
  setup(__props) {

const route = useRoute();
const router = useRouter();

onMounted(() => {
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_3))
}
}

})